
import { Component, Emit, Prop } from 'vue-property-decorator'
import { ChildComponentMixin } from '@/mixins'
import PartnersTableRow from '@/components/PartnersTableRow.vue'
import { cloneDeep } from 'lodash'

@Component({
    components: {
        PartnersTableRow,
    },
})
export default class PartnersTable extends ChildComponentMixin {
    @Prop() private value?: PartnerEntity[]

    get rows() {
        return this.value ?? []
    }

    get headers(): string[] {
        return ['Nome do sistema', 'CNPJ', 'Categoria', 'Integração', 'Acesso']
    }

    private onClickRow(id: number) {
        this.$router.push(`/partners/update/${id}`)
    }

}
